// This function accepts a string and an object containing breakpoint lengths for different classes
const getMaxWidthClass = (
  text,
  breakpoints = { small: 20, medium: 75, large: 100 }
) => {
  if (!text) return 'max-w-3xl'; // default, you might want to adjust

  const { length } = text;

  if (length <= breakpoints.small) {
    return 'max-w-3xl';
  }
  if (length <= breakpoints.medium) {
    return 'max-w-4xl';
  }
  if (length <= breakpoints.large) {
    return 'max-w-4xl';
  }
  return 'max-w-5xl';
};

export { getMaxWidthClass };
